exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr th {\r\n  text-align: center;\r\n  letter-spacing: 0.02em;\r\n  color:white;\r\n  background: #19457A;\r\n}\r\n\r\ntr td {\r\n  height: 10px;\r\n  padding: 0.2rem;\r\n}\r\n\r\n.ng-select.custom ::ng-deep .ng-value  {\r\n  color:#19457A;\r\n  font-weight:bold;\r\n}\r\n\r\n.table {\r\n  margin-top: 30px;\r\n}\r\n\r\n.date-input {\r\n  padding-left: 15px;\r\n  padding-right: 15px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.date-input-field {\r\n  min-width: 200px\r\n}\r\n\r\n.search-btn {\r\n  margin-top: 30px;\r\n}\r\n\r\n.details-btn-col {\r\n  vertical-align: middle;\r\n  text-align: center;\r\n  display: table-cell;\r\n}\r\n\r\n.content-center {\r\n  text-align: center;\r\n  vertical-align: middle;\r\n}\r\n\r\n.terminal-header-col {\r\n  vertical-align: middle;\r\n}\r\n\r\n@media only screen and (max-width: 1024px) {\r\n  [class=\"details-btn-col\"] {\r\n    width: 8%;\r\n  }\r\n}\r\n\r\n@media only screen and (min-width: 1025px) {\r\n  [class=\"details-btn-col\"] {\r\n    width: 5%;\r\n  }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/terminal-overview-report/terminal-overview-report.component.css
// module id = ../../../../../src/app/terminal-overview-report/terminal-overview-report.component.css
// module chunks = main